import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../../hooks/usePageMeta';
import { services } from '../../data/services';
import { PageHero } from '../../components/ui/PageHero';
import { TiltCard } from '../../components/ui/TiltCard';
import { Button } from '../../components/ui/Button';
import { Reveal } from '../../components/ui/Reveal';
import { CtaBand } from '../../components/ui/CtaBand';
export function Services() {
  usePageMeta('Our Services', 'Executive search, board appointments, permanent, interim and specialist recruitment, talent mapping and strategic talent advisory.');
  return <>
      <PageHero crumbs={[{
      label: 'Services'
    }]} kicker="Our services" title="Specialist search for every level of leadership." intro="Ten service lines, one consistent standard: a clear brief, a thoroughly researched market, rigorous assessment and discreet, personal handling." actions={<>
            <Button to="/employers#inquiry" size="lg" arrow data-id="element-1178" data-mp="1kbstyklkbrbi">
              Discuss Your Hiring Needs
            </Button>
            <Button to="/process" size="lg" variant="outlineLight" data-id="element-1179" data-mp="1fdr2pcdzgloy">
              Our search process
            </Button>
          </>} data-id="element-1177" data-mp="1t0lfe2rcor1d" />

      <section className="bg-ivory py-20" data-id="element-1180" data-mp="1t6gww43o0wx5">
        <div className="container-page" data-id="element-1181" data-mp="1ode2jtr2djfw">
          <h2 className="sr-only" data-id="element-1182" data-mp="1occsnslsb2zr">Service directory</h2>
          <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5" data-id="element-1183" data-mp="231r3l550dsh9">
            {services.map(s => {
            const Icon = s.icon;
            return <li key={s.slug} data-id="element-1184" data-mp="2c38febbdv805">
                  <TiltCard className="h-full" data-id="element-1185" data-mp="2c3i7q5jwhr90">
                    <Link to={s.slug === 'executive-search' ? '/executive-search' : `#${s.slug}`} className="flex h-full flex-col rounded-lg border border-line bg-white p-5 transition-[border-color,box-shadow] duration-200 hover:border-gold/60 hover:shadow-lift" data-id="element-1186" data-mp="2c14bhtdhi8zv">
                      <Icon className="h-6 w-6 text-gold-700" aria-hidden="true" data-id="element-1187" data-mp="2cslzxpyk7uoc" />
                      <span className="mt-4 font-display text-xl font-semibold leading-snug text-ink" data-id="element-1188" data-mp="2hrgs3iif2vl4">{s.title}</span>
                      <span className="mt-2 text-sm leading-relaxed text-muted" data-id="element-1189" data-mp="2mq0fzogkmhg4">{s.summary}</span>
                    </Link>
                  </TiltCard>
                </li>;
          })}
          </ul>
        </div>
      </section>

      <div className="bg-white" data-id="element-1190" data-mp="2vqotmi21yfsh">
        {services.map((s, i) => {
        const Icon = s.icon;
        return <section key={s.slug} id={s.slug} aria-labelledby={`${s.slug}-title`} className="border-t border-line py-20 first:border-t-0" data-id="element-1191" data-mp="30o8azqu1r8on" data-mpi={i}>
              <div className="container-page grid gap-12 lg:grid-cols-12" data-id="element-1192" data-mp="3agnskn1flv90">
                <Reveal className="lg:col-span-5" data-id="element-1193" data-mp="3ff7foqrrhd2y">
                  <div className="flex h-12 w-12 items-center justify-center rounded-md bg-midnight text-gold-300" data-id="element-1194" data-mp="3fgijgql7iku2">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-1195" data-mp="3jh2cpj2nt4ax" />
                  </div>
                  <p className="mt-6 font-display text-lg text-gold-700" data-id="element-1196" data-mp="17v0fn5ouaef3">{String(i + 1).padStart(2, '0')} / 10</p>
                  <h2 id={`${s.slug}-title`} className="mt-1 font-display text-4xl font-semibold leading-tight text-ink" data-id="element-1197" data-mp="13tygspyu44dn">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-1198" data-mp="tuzerq8kr6zm">{s.description}</p>
                  <div className="mt-8 flex flex-wrap gap-3" data-id="element-1199" data-mp="1rg4yk3y28yh2">
                    <Button to={`/contact?pathway=employer&service=${s.slug}`} variant="navy" arrow data-id="element-1200" data-mp="1miln1bsqyzst">
                      Inquire about this service
                    </Button>
                    {s.slug === 'executive-search' && <Button to="/executive-search" variant="outline" data-id="element-1201" data-mp="1crqz82zurs59">
                        Executive search in detail
                      </Button>}
                  </div>
                </Reveal>
                <div className="grid gap-8 sm:grid-cols-3 lg:col-span-7" data-id="element-1202" data-mp="25fwjkomzvf4k">
                  <div data-id="element-1203" data-mp="1pyeqia6ky5m6">
                    <h3 className="text-sm font-medium text-ink" data-id="element-1204" data-mp="1pxwnmupewt5a">Benefits</h3>
                    <ul className="mt-4 space-y-3" data-id="element-1205" data-mp="1u1kwdgps5us4">
                      {s.benefits.map(b => <li key={b} className="flex gap-3 text-[15px] leading-relaxed text-muted" data-id="element-1206" data-mp="1g2l501avv1s9">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" data-id="element-1207" data-mp="1l0mylg5xqjhz" />
                          {b}
                        </li>)}
                    </ul>
                  </div>
                  <div data-id="element-1208" data-mp="1yzw3hjooxr6n">
                    <h3 className="text-sm font-medium text-ink" data-id="element-1209" data-mp="1z0e9h815njrr">Typical use cases</h3>
                    <ul className="mt-4 space-y-3" data-id="element-1210" data-mp="23ypk3kz9xyb1">
                      {s.useCases.map(u => <li key={u} className="flex gap-3 text-[15px] leading-relaxed text-muted" data-id="element-1211" data-mp="2roti9ctp15un">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-royal" aria-hidden="true" data-id="element-1212" data-mp="2wf0admnez8hn" />
                          {u}
                        </li>)}
                    </ul>
                  </div>
                  <div className="rounded-lg bg-ivory p-5" data-id="element-1213" data-mp="g0evu17sd3bq">
                    <h3 className="text-sm font-medium text-ink" data-id="element-1214" data-mp="tt4lqgqfqse4">Process</h3>
                    <ol className="mt-4 space-y-3" data-id="element-1215" data-mp="tuft0qj3ai9z">
                      {s.process.map((p, idx) => <li key={p} className="flex gap-3 text-[15px] text-ink/85" data-id="element-1216" data-mp="21fd1a6yfinh" data-mpi={idx}>
                          <span className="font-display text-base text-gold-700" data-id="element-1217" data-mp="239wek2kv2pg">{idx + 1}</span>
                          {p}
                        </li>)}
                    </ol>
                  </div>
                </div>
              </div>
            </section>;
      })}
      </div>

      <CtaBand title="Not sure which service fits?" text="Tell us about the role or challenge and we will recommend the right approach." primary={{
      label: 'Contact us',
      to: '/contact'
    }} secondary={{
      label: 'Employer FAQs',
      to: '/faq#employers'
    }} data-id="element-1218" data-mp="1mh0fpdome677" />
    </>;
}